import { has } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refSpecies", "refSubObjective"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                const refType = modelRef?.refType?.key
                if(refType === "media"){
                    modelRef.refSpecies = null
                    modelRef.refSubObjective = null
                }
                return refType != "media"
            }
        },
        {
            check: ({ field }) => {
                return ["solid"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                if(!modelRef.isSolid){
                    modelRef.solid = null
                } else {
                    modelRef.liquid = null
                    modelRef.isLiquid = false
                }
                return ({ disabled: !modelRef.isSolid || props.viewOnly })
            }
        },
        {
            check: ({ field }) => {
                return ["liquid"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                if(!modelRef.isLiquid){
                    modelRef.liquid = null
                } else {
                    modelRef.solid = null
                    modelRef.isSolid = false
                }
                return ({ disabled: !modelRef.isLiquid || props.viewOnly })
            }
        }
    ];
};
